export default "__VITE_ASSET__fc7907b0__"